import "./Home.module.css";
import CorporateCoffeeCapsulesAndMachines from "@/reusable_sections/Header";
import CapsulesCompatiblesDolceGustoTassimo from "./sections/CapsulesCompatiblesDolceGustoTassimo";
import OutilsDePrecisionProBanner from "./sections/OutilsDePrecisionProBanner";
import NeedHelp from "./sections/NeedHelp";
export default function HomePage() {
  return <div>
      <CorporateCoffeeCapsulesAndMachines />
      <CapsulesCompatiblesDolceGustoTassimo />
      <OutilsDePrecisionProBanner />
      <NeedHelp />
    </div>;
}